import { StringDevUIField } from "./StringDevUIField";
import { resolveDevtoolsIcon } from "../../StringDevIconRegistry";

export class StringDevFieldSelect extends StringDevUIField<string> {
  private options: ReadonlyArray<{ value: string; label: string }>;
  private select: HTMLSelectElement | null = null;
  private stepperButtons: HTMLButtonElement[] = [];

  constructor(
    key: string,
    label: string,
    defaultValue: string,
    onChange: (key: string, value: string) => void,
    options: ReadonlyArray<{ value: string; label: string }>,
  ) {
    super(key, label, defaultValue, onChange);
    this.options = options;
  }

  build(): HTMLElement {
    const row = this.createRow();
    row.appendChild(this.createLabel());
    row.appendChild(this.createControl());
    this.root = row;
    return row;
  }

  setValue(value: string): void {
    this.value = value;
    if (this.select) this.select.value = value;
  }

  override setDisabled(disabled: boolean): void {
    super.setDisabled(disabled);
    if (this.select) this.select.disabled = disabled;
    for (const button of this.stepperButtons) {
      button.disabled = disabled;
    }
  }

  private createControl(): HTMLDivElement {
    const shell = document.createElement("div");
    shell.setAttribute("data-stdg-field-input", "");

    const select = document.createElement("select");
    select.setAttribute("data-stdg-select", "");

    for (const opt of this.options) {
      const option = document.createElement("option");
      option.value = opt.value;
      option.textContent = opt.label;
      if (opt.value === this.value) option.selected = true;
      select.appendChild(option);
    }

    select.addEventListener("change", () => {
      this.emit(select.value);
    });

    this.select = select;

    const stepper = document.createElement("div");
    stepper.setAttribute("data-stdg-stepper", "");
    stepper.appendChild(this.createStepperButton("up", -1));
    stepper.appendChild(this.createStepperButton("down", 1));

    shell.appendChild(select);
    shell.appendChild(stepper);
    return shell;
  }

  private createStepperButton(directionName: "up" | "down", direction: 1 | -1): HTMLButtonElement {
    const button = document.createElement("button");
    button.type = "button";
    button.setAttribute("data-stdg-button", "");
    button.setAttribute("data-stdg-button-icon-12", "");
    button.setAttribute("data-direction", directionName);
    button.innerHTML = resolveDevtoolsIcon(
      12,
      directionName === "up" ? "chevrone-up" : "chevrone-down",
    );
    button.addEventListener("click", () => {
      if (!this.select) return;
      const count = this.select.options.length;
      if (count === 0) return;
      const currentIndex = this.select.selectedIndex;
      const nextIndex = (((currentIndex + direction) % count) + count) % count;
      this.select.selectedIndex = nextIndex;
      this.emit(this.select.value);
    });
    this.stepperButtons.push(button);
    return button;
  }
}
